import styled from "styled-components";

export const Header = styled.header`
    border-bottom: 1px solid #ddd;
    box-shadow: 1px 6px 5px -6px #eee;
    padding: 2rem 0;
    position: relative;
    width: 100%;
    grid-column-start: 2;

    @media(max-width: 860px) {
        grid-column-start: 1;
        box-shadow: none;
        border-bottom: none;
    }
    
`;

export const SubscribeLink = styled.a`
    border-radius: 15px;
    background: linear-gradient(to right, #FA578E, #FDA88E);
    color: #fff;
    display: block;
    position: absolute;
    width: 100px;
    top: 38%;
    text-align: center;
    right: 4%;
    padding: 0.5rem 1rem;
    font-size: 1.6rem;
    transition: all 200ms ease;

    
    &:hover {
        background: linear-gradient(to right, #fb89af, #fdb9a4);+
    }

    &:focus {
        outline: none;
    }

    &:active {
        transform: scale(0.9);
    }

    @media(max-width: 490px) {
        display: none;
    }
`;

export const Title = styled.h1`
    margin: 0;  
    font-family: 'Playfair Display', serif;
    font-size: 4.2rem;
    text-align: center;

`;

